import { Stack } from 'immutable';

const initialState = {
    undoStack: Stack(),
    redoStack: Stack()
};

export default (state = initialState) => state;
